import React, { useState } from 'react';
import { Field } from 'redux-form';
import styled from 'styled-components';
import { Col, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import { Button } from '../../../../common/components';
import { actions } from '../../../../common/components/Postcode/redux/PostcodeActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Select from 'react-select';
import { map } from 'lodash';
import { required } from 'redux-form-validators';
import { ValidationError } from '../StyledComponents/StyledComponents';
const uppercase = (value) => value && value.toUpperCase();

const isRequired = required({ message: 'Field is Required' });
const StyledButton = styled(Button)`
  margin-top: ${(props) => (props.showError ? '13px' : '0')};
  width: 100%;
`;

const ValidationState = ({ showError, children }) => {
  return <ValidationError showError={showError}>{children}</ValidationError>;
};

const ErrorMessage = styled.span`
  color: #cf2631;
  font-size: smaller;
`;

const LabelText = styled(ControlLabel)`
    font-size: 16px;
    font-weight: normal;
`;

const Input = ({ input, placeholder }) => {
  const onChange = (value) => {
    input.onChange(value);
  };
  return <FormControl {...input} onChange={onChange} placeholder={placeholder} />;
};

const PostCodeLookup = ({
  input,
  meta,
  labelSize,
  label,
  infoButton,
  handlePostcodeSearch,
  isLoading,
}) => {
  const showError = meta.touched && meta.error;
  return (
    <>
      <FormGroup>
        <Col sm={labelSize || 2}>
          <LabelText>
            {label}
            {infoButton}
          </LabelText>
        </Col>
        <Col sm={4}>
          <ValidationState showError={showError}>
            <Field
              normalize={uppercase}
              name={input.name}
              placeholder={'Postcode'}
              component={Input}
              validate={isRequired}
            />
            {showError && <ErrorMessage> {meta.error} </ErrorMessage>}
          </ValidationState>
        </Col>
        <Col sm={2}>
          <div>
            <StyledButton
              showError={showError}
              type="button"
              bsStyle="primary"
              handleClick={() => handlePostcodeSearch(input.value)}
              isLoading={isLoading}
            >
              Search
            </StyledButton>
          </div>
        </Col>
      </FormGroup>
    </>
  );
};

const PostcodeSelect = ({ handleAddressSelect, addresses, labelSize }) => {
  const options = map(addresses, (address) => {
    return {
      label: address.attributes.name,
      value: address.id,
    };
  });
  return (
    <FormGroup>
      <Col sm={12 - labelSize} smOffset={labelSize}>
        <Select
          onChange={handleAddressSelect}
          options={options}
          placeholder="Please select your address from the following..."
          isClearable={false}
        />
      </Col>
    </FormGroup>
  );
};

const AddressFields = ({ colSize, labelSize, input, meta, required }) => (
  <>
    <FormGroup>
      <Col sm={colSize} smOffset={labelSize}>
        <ValidationState
          showError={meta.line1 && meta.line1.touched && meta.error && meta.error.line1}
        >
          <Field
            name={input.name + '.line1'}
            placeholder="Line 1"
            component={Input}
            validate={required ? isRequired : null}
          />
          {meta.line1 && meta.line1.touched && meta.error && meta.error.line1 && (
            <ErrorMessage>{meta.error.line1} </ErrorMessage>
          )}
        </ValidationState>
      </Col>
    </FormGroup>

    <FormGroup>
      <Col sm={colSize} smOffset={labelSize}>
        <Field name={input.name + '.line2'} placeholder="Line 2" component={Input} />
      </Col>
    </FormGroup>

    <FormGroup>
      <Col sm={colSize} smOffset={labelSize}>
        <ValidationState
          showError={meta.town && meta.town.touched && meta.error && meta.error.town}
        >
          <Field
            name={input.name + '.town'}
            placeholder="Town"
            component={Input}
            validate={required ? isRequired : null}
          />
          {meta.town && meta.town.touched && meta.error && meta.error.town && (
            <ErrorMessage>{meta.error.town} </ErrorMessage>
          )}
        </ValidationState>
      </Col>
    </FormGroup>

    <FormGroup>
      <Col sm={colSize} smOffset={labelSize}>
        <ValidationState
          showError={
            meta.county && meta.county.touched && meta.error && meta.error.county
          }
        >
          <Field
            name={input.name + '.county'}
            placeholder="County"
            component={Input}
            validate={required ? isRequired : null}
          />
          {meta.county && meta.county.touched && meta.error && meta.error.county && (
            <ErrorMessage>{meta.error.county} </ErrorMessage>
          )}
        </ValidationState>
      </Col>
    </FormGroup>
  </>
);

const Address = ({
  input,
  meta,
  colSize,
  labelSize,
  label,
  actions,
  updateAddress,
  required,
}) => {
  const [addressList, setAddressList] = useState([]);
  const [loading, isLoading] = useState(false);
  const handlePostcodeSearch = (postcode) => {
    isLoading(true);
    Promise.resolve(actions.getAddresses(postcode))
      .then((resp) => {
        setAddressList(resp.data);
        isLoading(false);
      })
      .catch(() => {
        isLoading(false);
      });
  };
  const handleAddressSelect = (address) => {
    Promise.resolve(actions.getAddress(address.value)).then((address) => {
      updateAddress(address.attributes);
      setAddressList([]);
    });
  };
  return (
    <div key={input.name}>
      <Field
        name={`${input.name}.postcode`}
        component={PostCodeLookup}
        label={label}
        labelSize={labelSize}
        colSize={colSize}
        isLoading={loading}
        validate={required ? isRequired : null}
        handlePostcodeSearch={handlePostcodeSearch}
      />

      {addressList.length > 0 && (
        <PostcodeSelect
          handleAddressSelect={handleAddressSelect}
          addresses={addressList}
          labelSize={labelSize}
        />
      )}
      <AddressFields
        input={input}
        meta={meta}
        colSize={colSize}
        labelSize={labelSize}
        required={required}
      />
    </div>
  );
};

export default connect(
  null,
  (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
    dispatch,
  }),
)(Address);
